// Copyright 2025 Linka Cloud  All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ErrorBoundary } from '@linka-cloud/components/ErrorBoundary';
import { GlobalStyles } from '@mui/material';
import { AppCacheProvider, createEmotionCache } from '@mui/material-nextjs/v15-pagesRouter';
import { ThemeProvider } from '@mui/material/styles';
import Head from 'next/head';
import * as React from 'react';
import '../theme/theme.css';
import '../styles/globals.css';
import { theme } from '../theme/theme';

const clientCache = createEmotionCache({ key: 'css', enableCssLayer: true });

export default function App({ emotionCache = clientCache, ...props }: any) {
  const { Component, pageProps } = props;
  return (
    <AppCacheProvider emotionCache={emotionCache}>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
        <meta charSet="utf-8" />
        <link rel="icon" href="/static/favicon.ico" />
        <meta name="description" content="LKR Web Console" />
        <link rel="apple-touch-icon" href="/static/apple-touch-icon.png" />
        <link rel="manifest" href="/static/manifest.json" />
        <title>LKR</title>
      </Head>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles="@layer theme, base, mui, components, utilities;" />
        <ErrorBoundary>
          <Component {...pageProps} />
        </ErrorBoundary>
      </ThemeProvider>
    </AppCacheProvider>
  );
}
